// extracted by mini-css-extract-plugin
module.exports = {"highlightedText":"styles_highlightedText__3xQnE"};